<template>
  <div>
    <dd-modal v-if="extensions" :visible="showChooseExtensionModal" @close="closeChooseExtensionModal">
      <dd-header-card header="Kies een extensie">
        <dd-radio-group>
          <dd-radio v-for="extension of extensions" :key="extension.id">
            {{ extension }}
          </dd-radio>
        </dd-radio-group>
      </dd-header-card>
    </dd-modal>
    <a-dropdown>
      <dd-button type="primary" :outline="true" class="square-button">
        <template #icon>
          <PhoneIcon class="icon-size-md"></PhoneIcon>
        </template>
      </dd-button>
      <template #overlay>
        <dd-card>
          <ul class="flex-col gap-y-sm">
            <li class="flex-col">
              <strong>Maatschappij</strong>
              <a @click="callNumber(agency.phone)" class="phone_number" v-if="agency.phone">{{ agency.phone }}</a>
            </li>

            <li v-if="hasDepartments" class="flex-col">
              <strong>Afdelingen</strong>
              <ul>
                <li v-for="(department) of agency.departments.data" :key="department.id">
                  <a @click="callNumber(department.phone)" v-if="department.phone">{{ department.phone }}</a>
                  <strong>Werknemers</strong>
                  <ul>
                    <li v-for="(employee, index) of department.employees.data" :key="employee.id">
                      <div class="flex-row gap-sm">
                      <span>
                        {{employee.name }}
                      </span>
                        <a @click="callNumber(employee.phone)">
                        {{ employee.phone }}
                      </a>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </dd-card>
      </template>
    </a-dropdown>

  </div>
</template>

<script>
import voipApi from '~/api/voip';

export default {
  name: "PhoneButton.vue",
  props: {
    extensions: Array,
    activeExtension: Number,
    agency: {
      departments: {
        employees: {
          type: Object,
          required: false,
        }
      }
    }
  },
  data() {
    return {
      showChooseExtensionModal: false,
      meHasLoaded: false,
    }
  },
  computed: {
    hasDepartments() {
      return this.agency.departments.data.length > 0;
    }
  },
  methods: {
    callNumber(number) {
      voipApi.outgoingCall(number).catch((e) => {
        alert('Er ging iets mis tijdens het uitbellen.');
      });
    },
    openChooseExtensionModal() {
      this.showChooseExtensionModal = true;
    },
    closeChooseExtensionModal() {
      this.showChooseExtensionModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
